module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu-wrap"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.goMenu
    }
  }), _vm._v(" "), (_vm.config && _vm.isShow) ? _c('app-menu', {
    attrs: {
      "show": _vm.isShow,
      "data": _vm.config
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67614720"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-menu/index.vue
// module id = 196
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 15 16 17 19 23 27 28 30 36 39 40 44 45